/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
*/

import { HttpParams } from "@angular/common/http";
import { RboChart } from "@src/app/modules/agent/agent-dashboard-page/RboChart";

export class RboMyRequestsChart extends RboChart {
    title = "My Requests Top OMCs";
    dataParams = new HttpParams().set('week', 0).set('show', 'myrequests');
}
